import { render, staticRenderFns } from "./DeleteSinglePositionID.vue?vue&type=template&id=40c02fa7&scoped=true&"
import script from "./DeleteSinglePositionID.vue?vue&type=script&lang=js&"
export * from "./DeleteSinglePositionID.vue?vue&type=script&lang=js&"
import style0 from "./DeleteSinglePositionID.vue?vue&type=style&index=0&id=40c02fa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c02fa7",
  null
  
)

export default component.exports